import logo from './logo.svg';
import './App.scss';

function App() {
  return (
    <div className="App">
      <div className="baner" />
      <div className="title">
        AVISO DE PRIVACIDAD
      </div>
      <div className="contenido">
        <p>
          TPS EMPRESARIAL, S.A. DE C.V. (“SUMA”), sabe y conoce la importancia de sus datos personales, por lo que en el tratamiento de sus datos se observarán los principios de licitud, consentimiento, información, calidad, finalidad, lealtad, proporcionalidad y responsabilidad, que están previstos en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en lo sucesivo la “Ley”).
        </p>
        <p>
          En los términos de los artículos 15, 16, 17 y demás relativos de la Ley, le informamos lo siguiente:
        </p>
        <p>
          <u>Finalidad del tratamiento de datos personales:</u>
        </p>
        <p>
          La obtención y tratamiento de sus datos personales tiene las siguientes finalidades:
        </p>
        <p className='tab'>
          <p>
            a)	Cumplir con las disposiciones legales que apliquen para tal efecto, lo que puede implicar notificar a las autoridades en los supuestos de ley.
          </p>
          <p>
            b)	La gestión, operación, actualización, mantenimiento, administración y uso de una aplicación móvil y plataforma de internet para uso de los operadores de las unidades de transporte de SUMA y personal administrativo, que tiene como finalidad el rastreo y asignación de rutas, bitácoras y demás funcionalidades relacionadas, que será de uso interno para la empresa.
          </p>
        </p>
        <p>
          Las anteriores finalidades son aquellas que dieron origen y son necesarias para la relación entre SUMA y sus operadores.
        </p>
        <p>
          En caso de que se pretendan tratar sus datos personales para un fin distinto que no resulte compatible o análogo a los fines establecidos en el presente aviso de privacidad, solicitaremos su consentimiento para ello.
        </p>
        <p>
          Cualquier duda o aclaración que tenga al respecto, o en caso de que tenga alguna objeción con el tratamiento de sus datos personales, favor de comunicarla al correo electrónico del Ingeniero de Soporte, correo soporte@suma.mx, encargado de la atención en lo relativo a la protección de sus datos personales, o manifestarlo por escrito en nuestro domicilio al momento en que se le puso a disposición el presente aviso de privacidad.
        </p>
        <p>
          Si se le puso a disposición el presente aviso de forma indirecta o impersonal, usted tendrá un plazo de cinco días hábiles para que manifieste su negativa (en los términos del párrafo anterior) para el tratamiento de sus datos personales.

        </p>
        <p>
          <u>Datos personales materia del tratamiento:</u>
        </p>
        <p>
          Con el objeto de lograr las finalidades antes señaladas, los datos que se le podrán requerir son los siguientes:
        </p>
        <p className='tab'>
          <p>
            •	Nombre completo.
          </p>
          <p>
            •	Números telefónicos, incluido número de celular.
          </p>
          <p>
            •	Voz, a través de micrófono.
          </p>
          <p>
            •	Imagen, a través de cámara fotográfica y videos.
          </p>
        </p>
        <p>
          La anterior información se solicitará en la medida que se necesite, misma que variará de acuerdo al asunto de que se trate.
        </p>
        <p>
          Las vulneraciones de seguridad ocurridas en cualquier fase del tratamiento de sus datos que afecten de forma significativa sus derechos patrimoniales o morales, le serán informadas de forma inmediata a fin de que usted pueda tomar las medidas correspondientes a la defensa de sus derechos.
        </p>
        <p>
          Le informamos que toda comunicación no protegida realizada a través de Internet puede ser objeto de intercepción, pérdida o posibles alteraciones, por lo que usted no podrá exigir alguna indemnización por cualquier daño resultante por dichos conceptos.
        </p>
        <p>
          <u>
            Transferencia de datos personales:
          </u>
        </p>
        <p>
          La transferencia de sus datos personales a terceros se hará en los siguientes supuestos:
        </p>
        <p className='tab'>
          •	Cuando se dé uno de los supuestos a que se refiere el artículo 37 de la Ley, se hará a las personas señaladas en dicho precepto.
        </p>
        <p>
          <u>
            Ejercicio de los derechos ARCO, del derecho a revocar su consentimiento y del derecho a limitar el uso o divulgación de sus datos personales:
          </u>
        </p>
        <p>
          La solicitud de acceso, rectificación, cancelación u oposición a sus datos personales, de revocación de su consentimiento para el uso de los mismos, así como la limitación al uso o divulgación de éstos, deberá contener y acompañar lo siguiente:
        </p>
        <p className='tab'>
          <p>
            •	Su nombre, domicilio y cualquier medio para comunicarle su respuesta;
          </p>
          <p>
            •	Identificación oficial vigente que acredite su identidad.
          </p>
          <p>
            •	Tratándose de su representante, deberá acreditar su identidad (la propia del representante), así como los documentos que acrediten su representación (poder, asamblea, etc.).
          </p>
          <p>
            •	La descripción clara y precisa de los datos personales respecto de los que se busca ejercer alguno de los derechos antes mencionados, y Cualquier otro elemento o documento que facilite la localización de los datos personales.
          </p>
        </p>
        <p>
          La anterior solicitud deberá ser entregada por escrito a nuestro domicilio o bien, enviada vía correo electrónico al correo del Ingeniero de Soporte, correo soporte@suma.mx.
        </p>
        <p>
          Tratándose de solicitudes de rectificación de datos personales, usted deberá indicar además de lo señalado anteriormente, las modificaciones a realizarse y aportar la documentación que sustente su petición.
        </p>
        <p>
          Tratándose de la limitación al uso o divulgación de sus datos personales, usted podrá manifestar por escrito su negativa.
        </p>
        <p>
          Nosotros le comunicaremos en un plazo máximo de veinte días, contados desde la fecha en que se recibió la solicitud, la determinación adoptada, a efecto de que, si resulta procedente, se haga efectiva la misma dentro de los quince días siguientes a la fecha en que se comunica la respuesta.
        </p>
        <p>
          En caso de solicitud de acceso a la información, ésta se pondrá a su disposición mediante la expedición de copias simples, documentos electrónicos o cualquier otro medio idóneo para tal efecto. La entrega de los datos personales será gratuita, debiendo cubrir usted únicamente los gastos justificados de envío o con el costo de reproducción en copias u otros formatos.
        </p>
        <p>
          Si desea saber el estatus de su solicitud, favor de mandar un correo al Ingeniero de Soporte, correo soporte@suma.mx, quien le informará el avance de la misma.
        </p>
        <p>
          <u>Contacto:</u>
        </p>
        <p>
          En caso de que haya alguna modificación al presente Aviso de privacidad, se la comunicaremos mediante correo electrónico, personalmente o mediante cualquier medio idóneo para tal efecto.
        </p>
        <p>
          Cualquier duda, aclaración o inconformidad sobre el contenido del presente Aviso, favor de comunicarlo a la dirección de correo electrónico del Ingeniero de Soporte, correo soporte@suma.mx.
        </p>
        <p>
          Si usted considera que su derecho a la protección de datos personales ha sido vulnerado, puede acudir ante el Instituto Federal de Acceso a la Información y Protección de Datos (IFAI). Para mayor información visite https://home.inai.org.mx
        </p>
        <p>
          Domicilio
        </p>
        <p>
          Calle San Pedro y San Pablo 355, El Campanario, C.P. 45609, Zapopan, Jalisco.
        </p>
        <p>
          Última actualización
        </p>
        <p>
          08/02/2024
        </p>
      </div>
      <div className='footer'></div>
    </div>
  );
}

export default App;
